var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValidSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9799 8C15.9799 12.5973 12.1066 16.2896 7.47311 16C3.49121 15.7466 0.233287 12.4887 0.0160926 8.50679C-0.2735 3.8733 3.38261 0 7.97989 0C9.78985 0 11.455 0.615385 12.7944 1.62896C13.084 1.84615 13.084 2.24434 12.8668 2.49774L7.7627 7.60181C7.32831 8 6.64053 8 6.24234 7.60181L4.72198 6.08145C4.43238 5.75566 3.9256 5.75566 3.5998 6.08145L2.55003 7.13122C2.22424 7.45701 2.22424 7.9276 2.55003 8.25339L6.42333 12.1267C6.74912 12.4525 7.21971 12.4525 7.5455 12.1267L14.5681 5.10407C14.8577 4.81448 15.3645 4.92308 15.5093 5.32127C15.8351 6.15385 15.9799 7.05882 15.9799 8Z",
    fill: "#137709"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidSvg);
export default __webpack_public_path__ + "static/media/ValidSVG.27946b52.svg";
export { ForwardRef as ReactComponent };